function parseAllowedUserIds() {
	const raw = process.env.REACT_APP_SQL_ACCESS_USER_IDS;
	if (!raw) {
		return [];
	}

	return raw
		.split(",")
		.map((userId) => userId.trim())
		.filter(Boolean);
}

export function canUseSqlAccess(user) {
	const allowedUserIds = parseAllowedUserIds();

	if (!allowedUserIds.length || !user?.user_id) {
		return false;
	}

	return Number(user.superuser) === 1 && allowedUserIds.includes(String(user.user_id));
}
